import { BaseEntity, DefaultResponseWithData } from "./system";

export interface IAllLocationsResponse extends DefaultResponseWithData<ILocation[]> { }
export interface IWarehouseLocationsResponse extends DefaultResponseWithData<IWarehouseLocation[]> { }
export interface ILocationVehicleCountsResponse extends DefaultResponseWithData<ILocationVehicleCount[]> { }
export interface ILocationVehicleCountResponse extends DefaultResponseWithData<ILocationVehicleCount> { }

export enum LocationType {
  Yard = 0,
  Racking = 1
}

// In case we need a Point field:
// export interface Point {
//   x: number;
//   y: number;
// }

export interface ILocation extends BaseEntity {
  name: string;
  type: LocationType;
  capacity?: number | null;
  locationGroupId?: string | null;
  longitude?: number;
  latitude?: number;
  // point?: Point;
}

export interface ILocationVehicleCount {
  locationId: string;
  vehicleCount: number;
}


export interface IWarehouseLocation extends BaseEntity {
  displayName: string;
  capacity: number;
  // dto specific
  occupied?: number;
  isExcluded?: boolean;
}